import {
  environmentCommonValues as enEnvironmentCommonValues,
} from "./i18n/features/en/environment-common-values";
import {
  environmentCommonValues as jaEnvironmentCommonValues,
} from "./i18n/features/ja/environment-common-values";
import {
  environmentCommonValues as zhEnvironmentCommonValues,
} from "./i18n/features/zh/environment-common-values";
import {
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  normalizeLocale,
} from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": {
    platform: {
      environment: { common: { usageTypes: zhEnvironmentCommonValues.usageTypes } },
    },
  },
  en: {
    platform: {
      environment: { common: { usageTypes: enEnvironmentCommonValues.usageTypes } },
    },
  },
  ja: {
    platform: {
      environment: { common: { usageTypes: jaEnvironmentCommonValues.usageTypes } },
    },
  },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";
